<template>
	<div id="qe_left2">
		<div class="cc-header">人均活动次数</div>
		<div class="main-value" id="active_times"></div>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	const echarts = require("echarts");
	let activityCountChart;
	let pageSize = 6; //echarts每页显示数量
	export default {
		data() {
			return {
				start: 0,
				end: pageSize - 1,
				total: 0
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60);
			// 定时器轮播，5秒
			setInterval(() => {
				_this.dataZoomAutoScoll();
			}, 1000 * 5);
		},
		methods: {
			//echarts图标数据过多时，x轴自动滑动
			dataZoomAutoScoll() {
				const max = this.total - 1;
				if (pageSize < this.total) {
					if (this.end > max || this.start > max - pageSize) {
						this.start = 0;
						this.end = pageSize - 1;
					} else {
						this.start += 1;
						this.end += 1;
					}
					activityCountChart.dispatchAction({
						type: 'dataZoom',
						dataZoomIndex: 0,
						startValue: this.start,
						endValue: this.end
					});
				}
			},
			initData() {
				let _this = this;
				// 漏斗样式开始
				activityCountChart = echarts.init(document.getElementById("active_times"));
				this.$http.get("/dataView/quality/edu/getActivityAverage?orgCode=" + orgCode + "&termName=" + _this.$parent.$parent.$parent.termName).then(res => {
					if (res.data.code === 200) {
						var result = res.data.result;
						_this.total = result.xDatas.length;
						if (_this.$parent.$parent.$parent.termName == '2022-2023第二学期') {
							result.ydatas = [1, 3, 1, 4, 0, 2, 3, 2, 1, 2];
						}
						var option = {
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								},
								formatter: function(params) {
									var relVal = params[0].name;
									for (var i = 0; i < params.length; i++) {
										relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '</b>次';
									}
									return relVal
								}
							},
							dataZoom: [{
								type: 'inside',
								startValue: _this.start,
								endValue: _this.end,
							}],
							grid: {
								top: "12%",
								bottom: "26%"
							},
							xAxis: {
								type: 'category',
								data: result.xDatas,
								boundaryGap: true,
								axisLabel: {
									interval: 0,
									rotate: 25, // 角度
									formatter: function(value) {
										return (value.length > 6 ? (value.slice(0, 6) + "...") : 	value)
									},
									textStyle: {
										color: '#54beff',
										fontSize: fontSize(0.13)
									}
								},
								axisLine: {
									show: true
								},
								axisTick: {
									show: true
								},
								splitLine: {
									show: false
								}
							},
							yAxis: {
								type: 'value',
								splitLine: {
									show: false,
									lineStyle: {
										width: 10,
										color: 'rgba(255, 255, 255, 0.2)',
									}
								},
								axisLabel: {
									textStyle: {
										color: '#54beff',
										fontSize: fontSize(0.15)
									}
								},
								axisLine: {
									show: true
								},
								axisTick: {
									show: true
								}
							},
							series: [{
								name: '人均次数',
								data: result.ydatas,
								type: 'bar',
								itemStyle: {
									//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
									normal: {
										//柱形图圆角，初始化效果
										barBorderRadius: [10],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: "#9c6aff" // 0% 处的颜色
										}, {
											offset: 1,
											color: "#3e8bff" // 100% 处的颜色
										}], false)
									}
								},
								barGap: '0%',
								barWidth: 13
							}]
						};
						activityCountChart.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => activityCountChart.resize(), false);
					}
				})
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};


	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#qe_left2 {
		height: 100%;
		padding: 0 3%;

		.cc-header {
			width: 100%;
			padding-top: 0.25rem;
			color: #55ffff;
			font-size: 0.25rem;
			padding-left: 3%;
		}

		.main-value {
			height: 85%;
			padding-left: 3%;
		}

	}
</style>